export const NOTIFY_TYPES = {
  GET_NOTIFIES: "GET_NOTIFIES",
  CREATE_NOTIFY: "CREATE_NOTIFY",
  REMOVE_NOTIFY: "REMOVE_NOTIFY",
  UPDATE_NOTIFY: "UPDATE_NOTIFY",
  UPDATE_SOUND: "UPDATE_SOUND",
  DELETE_ALL_NOTIFIES: "DELETE_ALL_NOTIFIES",
};

const prefix = "notification";

export const NOTIFICATION_ENDPOINT = {
  BASE: prefix,
  READ_NOTIFICATION: `${prefix}/read`,
};

export const NOTIFICATION_QUERIES = {
  GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
  READ_NOTIFICATION: "READ_NOTIFICATION",
};
